document.querySelectorAll('.open-pictos-popup-button').forEach(item => {
    item.addEventListener('click', event => {
        console.log(item.dataset.id + '-pictos-popup')
        let p = document.getElementById(item.dataset.id + '-pictos-popup');
        p.classList.toggle('hidden');
        document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
    })
})

document.querySelectorAll('.close-pictos-popup-button').forEach(item => {
    item.addEventListener('click', event => {
        let p = document.getElementById(item.dataset.id + '-pictos-popup');
        p.classList.toggle('hidden');
        document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
    })
})
